import { LanguageCode } from 'common/src/vtj/LanguageCode.enum'
import { TFunction } from 'i18next'
import { finalEditableFieldValue } from 'todistukset-common/src/vtj/types/editable-field.type'
import {
  type TodistusPerson,
  TodistusPersonRole,
} from 'todistukset-common/src/vtj/types/todistus-person.type'

export function getSubjectPersons<
  PersonType extends Pick<TodistusPerson, 'roles'>
>(persons: PersonType[]): PersonType[] {
  return persons.filter((person) =>
    person.roles.includes(TodistusPersonRole.KOHDEHENKILO)
  )
}

export const getByRoleOrThrow = (
  todistusPersons: TodistusPerson[],
  expectedRole: TodistusPersonRole
): TodistusPerson => {
  const persons = todistusPersons.filter((p) => p.roles.includes(expectedRole))
  if (persons.length > 1) {
    throw new Error('Expected one person with role ' + expectedRole)
  } else if (persons.length === 0) {
    throw new Error('Expected a person with role ' + expectedRole)
  } else {
    return persons[0]
  }
}

export const getByRole = (
  todistusPersons: TodistusPerson[],
  expectedRole: TodistusPersonRole
): TodistusPerson | null => {
  try {
    return getByRoleOrThrow(todistusPersons, expectedRole)
  } catch (e) {
    return null
  }
}

export const getPersonFullName = (
  todistusPerson: Pick<TodistusPerson, 'firstNames' | 'lastName'> | undefined,
  t: TFunction,
  options: {
    unknownTranslationKey: string
    reversed?: boolean
  } = {
    unknownTranslationKey: 'unknownName',
    reversed: true,
  },
  lng: LanguageCode.FI | LanguageCode.SV | LanguageCode.EN = LanguageCode.FI
): string => {
  const unknownName = t(options.unknownTranslationKey, { lng })
  const firstNames =
    finalEditableFieldValue(todistusPerson?.firstNames ?? null) || unknownName
  const lastName =
    finalEditableFieldValue(todistusPerson?.lastName ?? null) || unknownName
  if (options.reversed === false) {
    return `${firstNames}, ${lastName}`
  }
  return `${lastName}, ${firstNames}`
}
